// extracted by mini-css-extract-plugin
export default {"cls1":"XyAsLeGRLQlCzF2sCB6a","cls2":"hLFql9QqcNYMYGWpGiEx XyAsLeGRLQlCzF2sCB6a","bookingAppRedesign":"oacYqFEoxArE5XQq8rER"};